import { Box, BoxProps, Stack, Text } from "@chakra-ui/react";
import Image from "next/image";
import { forwardRef } from "react";
import { I18nLink } from "../i18n/I18nLink";
import { getImageSrc } from "@/utils/file";
import { Lookbook } from "@/types/lookbook";
import { makeLookbookPageUrl } from "@/utils/product";

type Props = {
  lookbook: Lookbook;
} & BoxProps;

const LookbookShowcaseCard = forwardRef<HTMLDivElement, Props>(({ lookbook, ...boxProps }, ref) => {
  return (
    <I18nLink
      href={makeLookbookPageUrl(lookbook)}
      passHref
    >
      <Box
        ref={ref}
        aspectRatio={{ base: '188/322', lg: '325/400' }}
        className="product-card"
        px={{ base: "16px", md: "20px" }}
        py={{ base: "16px", md: "20px" }}
        height={{ base: "100%" }}
        width={'100%'}
        cursor={"pointer"}
        position="relative"
        overflow="hidden"
        _hover={{ backgroundColor: "#f5f5fd" }}
        {...boxProps}
      >
        <Box
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          zIndex={0}
        >
          <Image
            src={getImageSrc(lookbook, "main")}
            alt={lookbook?.name ?? "Lookbook"}
            fill
            quality={30}
            style={{ objectFit: "cover" }}
            className="product-image"
            priority
          />
        </Box>
        <Box
          visibility={{ base: 'visible', lg: 'hidden' }}
          className="gradient-overlay"
          position="absolute"
          bottom={0}
          left={0}
          width="100%"
          height="45%"
          pointerEvents="none"
          bgGradient="to-t"
          gradientFrom={"whiteAlpha.700"}
          gradientTo={"transparent"}
          opacity={1}
          zIndex={1}
        />
        <Stack
          position="relative"
          zIndex={1}
          height="100%"
          justifyContent={{ base: 'flex-end', lg: 'flex-start' }}
          gap="3px"
        >
          <Text
            className="product-name"
            textStyle={"bold16"}
            as={"b"}
            lineHeight={"20px"}
            lineClamp={2}
          >
            {lookbook?.name ?? "Lookbook"}
          </Text>
          {/* // ? TODO: рассмотреть как реализовать надписи, в текущем сайте нет такого у лукбука */}
          {/* <HStack>
            <Text textStyle="regular14" fontWeight={300} maxW="86px" color="black/50">
              s25 / drop1
              look n007
            </Text>
          </HStack> */}
        </Stack>
      </Box>
    </I18nLink>
  );
});

LookbookShowcaseCard.displayName = "LookbookShowcaseCard";
export default LookbookShowcaseCard;